import { AudioWaveform } from "@/components/MessageInput/components/AudioWaveform";
import { useAudioLevelMonitor } from "@/hooks/useAudioLevelMonitor";
import { cn } from "@/utils";
import { AudioDevice } from "@/utils/audioSettings";
import React from "react";

interface AudioLevelMonitorProps {
  device: AudioDevice | null;
  isEnabled?: boolean;
  className?: string;
  height?: number;
}

export const AudioLevelMonitor: React.FC<AudioLevelMonitorProps> = ({
  device,
  isEnabled = true,
  className,
  height = 40,
}) => {
  // Use the new hook that follows the same pattern as useAudioRecording
  const { audioLevel, isActive, hasError } = useAudioLevelMonitor({
    device,
    enabled: isEnabled,
  });

  if (!device) {
    return (
      <div
        className={cn(
          "flex items-center justify-center border rounded-lg bg-muted/30",
          className,
        )}
        style={{ height }}
      >
        <span className="text-xs text-muted-foreground">
          No microphone selected
        </span>
      </div>
    );
  }

  if (hasError) {
    return (
      <div
        className={cn(
          "flex items-center justify-center border rounded-lg bg-lc-blocked/10 dark:bg-spectrum-red-dark/20/30 border-lc-blocked/30 dark:border-spectrum-red-dark",
          className,
        )}
        style={{ height }}
      >
        <span className="text-xs text-lc-blocked dark:text-lc-blocked">
          Unable to access microphone
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center border rounded-lg bg-background px-3 py-2",
        className,
      )}
      style={{ height }}
    >
      {/* Use the existing AudioWaveform component - same as in recording */}
      <AudioWaveform
        audioLevel={audioLevel}
        isRecording={isActive}
        className="flex-1"
      />
    </div>
  );
};
